export default __webpack_public_path__ + "static/media/qrCodeIcon.694d6e07.svg";